import { render, staticRenderFns } from "./Ventas.vue?vue&type=template&id=0904701e&scoped=true&"
import script from "./Ventas.vue?vue&type=script&lang=js&"
export * from "./Ventas.vue?vue&type=script&lang=js&"
import style0 from "./Ventas.vue?vue&type=style&index=0&id=0904701e&lang=scss&scoped=true&"
import style1 from "./Ventas.vue?vue&type=style&index=1&id=0904701e&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0904701e",
  null
  
)

export default component.exports